export default (element) => element.getBoundingClientRect();
